import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-action-header-renderer',
  templateUrl: './action-header-renderer.component.html',
  styleUrls: ['./action-header-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ActionHeaderRendererComponent implements IHeaderAngularComp {
  private params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(params: IHeaderParams): boolean {
    return false;
  }

  onToggleColumnSelector(event: Event): void {
    event.stopPropagation();
    // Get the parent component through context
    const context = this.params.context;
    if (context && context.toggleColumnSelector) {
      context.toggleColumnSelector();
    }
  }

  onResetColumns(event: Event): void {
    event.stopPropagation();
    // Get the parent component through context
    const context = this.params.context;
    if (context && context.resetToDefaultLayout) {
      context.resetToDefaultLayout();
    }
  }
}
